import { IOptions } from "common/reactSelectModels";
import { selectTheme } from "components/CustomerCards/CustomerCardsSearchBar";
import { MeteringPoint } from "models/electricity/metering-point";
import React from "react";
import Select from "react-select";

const selectStyle = {
    indicatorSeparator: () => (
        {
            backgroundColor: 'red',
            width: '50px',
        }
    ),
};

interface MeteringPointSelectProps {
    meteringPoints: MeteringPoint[];
    selectedMeteringPoint?: IOptions;
    onMeteringPointChange: (value: IOptions) => void;
    withoutBorders?: boolean;

}
export default function MeteringPointSelect(props: MeteringPointSelectProps) {
    
    return (
        <Select
            options={props.meteringPoints.map(mp => ({ value: mp.id, label: mp.address + ' (' + mp.eic + ')' }))}
            styles={selectStyle}
            value={props.selectedMeteringPoint}
            isClearable={false}
            onChange={(value) => props.onMeteringPointChange(value as IOptions)}
            className={'mt-2 mt-md-0 w-100 select-terminal' + ( props.withoutBorders ? ' unbordered' : '' )}
            classNamePrefix={'select'}
            placeholder='Vali mõõtepunkt'
            theme={selectTheme}
        />
    )
}